import { render } from "./TreeViewDefaultItem.vue?vue&type=template&id=51f83429"
import script from "./TreeViewDefaultItem.vue?vue&type=script&lang=js"
export * from "./TreeViewDefaultItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__